import AccountForm from 'components/views/forms/account';

const component = {
  components: {
    'account-form': AccountForm,
  },
};

export default component;
